export default "__VITE_ASSET__CuYDiWPD__"